module.exports = __webpack_public_path__ + "img/fmcs_bg.6f871d3e.png";